import React from "react";
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt';
function Header() {
  return (
    <header>
      <h1>
         <OfflineBoltIcon /> Keeper, keeps you update</h1>
    </header>
  );
}

export default Header;
